import Tabs from '../../../components/common/Tabs'
import { managerPortalTabsData } from '../../../config/tabsConfig'
 import { FC } from 'react'

interface ManagerDocoumentsListProps {
  empNuid?: string | null;
}

const ManagerDocoumentsList: FC<ManagerDocoumentsListProps> = ({ empNuid }) => {
  return (
    <div>
      <Tabs tabs={managerPortalTabsData} extraProps={{ empNuid }} />
    </div>
  )
}

export default ManagerDocoumentsList

